function getAge(paramBDYear, paramBDMonth, paramBDDay, paramCalcDay) {

    const bdYear = parseInt(paramBDYear);
    const bdMonth = parseInt(paramBDMonth);
    const bdDay = parseInt(paramBDDay);
    const calcMonth = paramCalcDay.getMonth() + 1;

    let age = paramCalcDay.getFullYear() - bdYear;

    if (calcMonth < bdMonth || (calcMonth === bdMonth && paramCalcDay.getDate() < bdDay)) {
        age--;
    }

    return age;
}

function getKeisankijunbi(){
    const jstNowDate = this.getJstNowDate();
    const baseDay = new Date(jstNowDate.getFullYear(), jstNowDate.getMonth() + 1, 1);
    return baseDay;
}

function getJstNowDate() {
    const now = new Date();
    const epocTime = now.getTime();
    const offset = now.getTimezoneOffset() * 60 * 1000;
    const jstTime = epocTime + offset + 32400000;
    const jstDate = new Date(jstTime);
    return jstDate;
}
export default {getKeisankijunbi, getAge, getJstNowDate}